import React, { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import * as changeCase from 'change-case';
import PolicyStepsHeader from '../../../common/PolicyStepsHeader';
import SelectableAccordion from '../../../common/SelectableAccordion';
import useCustomerStore from '../../../../stores/customerStore';
import useLatestQuotesWithPolicies from '../../../../hooks/useLatestQuotesWithPolicies';
import useConfigStore from '../../../../stores/configStore';
import useWidgetStore, { CurrentTabEnum } from '../../../../stores/widgetStore';
import StartRequest from './StartRequest';
import useProductStore from '../../../../stores/productStore';
import useSaasPlatformStore from '../../../../stores/saasPlatformStore';
import shade from '../../../../utils/shade';
import HorseGroupSelection from './Broker/HorseGroupSelection';
var SelectApplicationDetails = function (_a) {
    var createQuoteMutation = _a.createQuoteMutation;
    var _b = useCustomerStore(), applicationFormData = _b.applicationFormData, recommendationEngine = _b.recommendationEngine, eligibilityEngine = _b.eligibilityEngine, policyAuditAiEngine = _b.policyAuditAiEngine;
    var applicationDataKeys = Object.keys(applicationFormData);
    var customerQuotes = useLatestQuotesWithPolicies();
    var _c = useConfigStore(), widgetType = _c.keys.widgetType, style = _c.style;
    var primaryColor = style.primaryColor, theme = style.theme;
    var Products = useSaasPlatformStore().Products;
    var _d = useWidgetStore(), applicationDataId = _d.applicationDataId, modalOpen = _d.modalOpen, setFormActive = _d.setFormActive, setModalOpen = _d.setModalOpen, handleAnswers = _d.setAnswers, setApplicationDataId = _d.setApplicationDataId, setCurrentTab = _d.setCurrentTab;
    var handleProduct = useProductStore().setProduct;
    var _e = useState(null), selectionError = _e[0], setSelectionError = _e[1];
    var _f = useState({ externalId: applicationDataKeys[0] }), selectedData = _f[0], setSelectedData = _f[1];
    var _g = useState([]), generatedQuotesExternalIds = _g[0], setGeneratedQuotesExternalIds = _g[1];
    var hasLoadableProduct = useMemo(function () {
        if (!(Products === null || Products === void 0 ? void 0 : Products.length) || !applicationFormData) {
            return false;
        }
        return Object.values(applicationFormData).some(function (applicationData) {
            return (applicationData === null || applicationData === void 0 ? void 0 : applicationData.productId) &&
                Products.some(function (product) { return product.id == applicationData.productId; });
        });
    }, [applicationFormData, Products]);
    var hasAlternativeStartFlow = Boolean(policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled) ||
        Boolean(eligibilityEngine) ||
        Boolean(recommendationEngine);
    var startRequestHelperText = !hasAlternativeStartFlow && !hasLoadableProduct
        ? 'No product is configured. Please review the widget configuration and try again.'
        : undefined;
    var startRequestButtonLabel = startRequestHelperText
        ? 'No Product Found'
        : widgetType == 'broker'
            ? 'Select Horses'
            : 'Start Request';
    var widgetFlow = useMemo(function () {
        var _a, _b;
        if (applicationFormData) {
            var policyKeys = Object.keys(applicationFormData);
            if (!policyKeys.length) {
                return;
            }
            var key = policyKeys[0];
            var applicationData_1 = applicationFormData[key];
            if (!applicationData_1) {
                return;
            }
            var findProd = (_a = Products === null || Products === void 0 ? void 0 : Products.find) === null || _a === void 0 ? void 0 : _a.call(Products, function (p) { return p.id == applicationData_1.productId; });
            return (_b = findProd === null || findProd === void 0 ? void 0 : findProd.Underwriter) === null || _b === void 0 ? void 0 : _b.widgetFlow;
        }
    }, [applicationFormData, Products]);
    useEffect(function () {
        if (selectedData &&
            generatedQuotesExternalIds.includes(selectedData.externalId)) {
            setSelectedData({
                externalId: applicationDataKeys.filter(function (v) { return !generatedQuotesExternalIds.includes(v); })[0]
            });
        }
    }, [generatedQuotesExternalIds]);
    useEffect(function () {
        if (customerQuotes && customerQuotes.length > 0) {
            var externalRefrenceOfQuotes = customerQuotes.map(function (quote) { return quote === null || quote === void 0 ? void 0 : quote.externalId; });
            setGeneratedQuotesExternalIds(externalRefrenceOfQuotes);
        }
    }, [customerQuotes]);
    useLayoutEffect(function () {
        var _a;
        if (applicationFormData && modalOpen) {
            var policyKeys = Object.keys(applicationFormData);
            if (!policyKeys.length) {
                return;
            }
            var key = policyKeys[0];
            var applicationData_2 = applicationFormData[key];
            if (!applicationData_2) {
                return;
            }
            var findProd = (_a = Products === null || Products === void 0 ? void 0 : Products.find) === null || _a === void 0 ? void 0 : _a.call(Products, function (p) { return p.id == applicationData_2.productId; });
            if (widgetType !== 'broker' &&
                findProd &&
                (policyKeys.length === 1 || findProd.productName === 'Unified Hiscox')) {
                setApplicationDataId(key);
                handleAnswers(applicationData_2.applicationDetails);
                handleProduct(findProd);
                setFormActive(true);
            }
        }
    }, [applicationFormData, modalOpen, widgetType, Products]);
    return (React.createElement("div", { className: modalOpen ? 'w-full overflow-x-hidden' : '', style: { animation: 'fadeSlideIn 220ms ease forwards', height: '100%' } }, modalOpen ? (widgetType == 'broker' && applicationFormData ? (React.createElement(HorseGroupSelection, { onClick: createQuoteMutation })) : (React.createElement("div", { className: "w-full h-full absolute top-0 flex flex-col items-center justify-start overflow-x-hidden sm:w-full" },
        React.createElement("div", { className: "w-full shadow-sm sticky top-0 bg-white" },
            React.createElement(PolicyStepsHeader, { nextButtonText: widgetType == 'broker' ? 'Agree & Continue' : 'Continue', backButtonText: "Close", pageName: "Select Data", isNextDisabled: !(selectedData.externalId &&
                    (applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId].productId)), handleNext: function () {
                    var _a, _b, _c, _d, _e;
                    if (widgetType == 'broker') {
                        var isEMR = (_b = (_a = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || '']) === null || _a === void 0 ? void 0 : _a.applicationDetails) === null || _b === void 0 ? void 0 : _b.HorseDetails;
                        if (!(isEMR &&
                            (isEMR === null || isEMR === void 0 ? void 0 : isEMR.length) == ((_c = isEMR === null || isEMR === void 0 ? void 0 : isEMR.data) === null || _c === void 0 ? void 0 : _c.length) &&
                            (isEMR === null || isEMR === void 0 ? void 0 : isEMR.length) <= 5)) {
                            setSelectionError({
                                key: selectedData.externalId,
                                message: 'One Policy Can Only Insure 5 or less Horses'
                            });
                            return;
                        }
                        createQuoteMutation({
                            requiredParams: (_d = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || '']) === null || _d === void 0 ? void 0 : _d.applicationDetails,
                            optionalParams: {}
                        }, (_e = applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || '']) === null || _e === void 0 ? void 0 : _e.productId, selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId);
                    }
                    else {
                        if ((selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId) &&
                            (applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || ''])) {
                            setApplicationDataId(selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId);
                            // setProduct(selectedData.applicationData.productId);
                            // setAnswers(selectedData.applicationData.applicationDetails);
                            handleAnswers(applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || ''].applicationDetails);
                            if (Products && (Products === null || Products === void 0 ? void 0 : Products.length) > 0) {
                                var findProd = Products.find(function (p) {
                                    return p.id ==
                                        (applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || ''].productId);
                                });
                                handleProduct(findProd);
                            }
                        }
                        else {
                            // setAnswers(null);
                            // setProduct(selectedData.applicationData.productId);
                            setApplicationDataId(selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId);
                            if (Products && (Products === null || Products === void 0 ? void 0 : Products.length) > 0) {
                                var findProd = Products.find(function (p) {
                                    return p.id ==
                                        (applicationFormData === null || applicationFormData === void 0 ? void 0 : applicationFormData[selectedData.externalId || ''].productId);
                                });
                                handleProduct(findProd);
                            }
                        }
                        setFormActive(true);
                    }
                } })),
        React.createElement("div", { className: "w-full p-6" },
            React.createElement("ul", { className: "bg-[#F8FAFE] p-1 rounded-[16px] flex justify-between mb-4 gap-1" }, applicationDataKeys.map(function (key) {
                var isSelected = (selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId) == key;
                return (!generatedQuotesExternalIds.includes(key) && (React.createElement("li", { key: key, className: "flex flex-1 items-center justify-center h-11 cursor-pointer ".concat(isSelected
                        ? 'bg-white text-primary rounded-[16px] shadow-[0_4px_12px_0px_#1F27510D] font-semibold'
                        : 'text-[#A5A9B9] font-medium', " "), onClick: function () {
                        if (applicationFormData) {
                            setSelectedData({
                                externalId: key
                            });
                        }
                    } }, changeCase.sentenceCase(key))));
            })),
            React.createElement("div", null, Object.keys(applicationFormData).map(function (key) {
                var _a, _b;
                return (!generatedQuotesExternalIds.includes(key) && (React.createElement(SelectableAccordion, { key: key, title: key, data: applicationFormData && applicationFormData[key], handleSelectData: function () {
                        if (applicationFormData)
                            setSelectedData({
                                externalId: key
                            });
                    }, isDataAvailable: applicationFormData &&
                        ((_a = applicationFormData[key]) === null || _a === void 0 ? void 0 : _a.applicationDetails), productId: applicationFormData &&
                        ((_b = applicationFormData[key]) === null || _b === void 0 ? void 0 : _b.productId), isSelected: (selectedData === null || selectedData === void 0 ? void 0 : selectedData.externalId) == key, selectionError: selectionError && (selectionError === null || selectionError === void 0 ? void 0 : selectionError.key) == key
                        ? selectionError === null || selectionError === void 0 ? void 0 : selectionError.message
                        : null })));
            })))))) : (React.createElement(StartRequest, { theme: theme, style: {
            backgroundColor: theme == 'night'
                ? shade(primaryColor, -0.7)
                : shade(primaryColor, 0.9)
        }, isButtonDisabled: Boolean(startRequestHelperText), disabledTooltip: startRequestHelperText, handleClick: function () {
            if (policyAuditAiEngine === null || policyAuditAiEngine === void 0 ? void 0 : policyAuditAiEngine.enabled) {
                setCurrentTab(CurrentTabEnum.POLICY_AUDIT_AI_RECOMMENDED_POLICIES);
            }
            else if (eligibilityEngine) {
                setCurrentTab(CurrentTabEnum.ELIGIBILITY_ENGINE);
            }
            else if (recommendationEngine) {
                setCurrentTab(CurrentTabEnum.BUSINESS_TYPE_SELECTION);
            }
            setModalOpen(true);
        }, buttonLabel: startRequestButtonLabel, isBroker: widgetType == 'broker', widgetFlow: widgetFlow }))));
};
export default SelectApplicationDetails;
